import React, { useContext } from 'react'
import UserContext from '../../context/Globales/UserContext';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";



const useStyles = makeStyles((theme) => ({

    root: {
        background: 'white',
        backgroundColor: theme.palette.fondotitulos.main,
        marginTop: theme.spacing(8),
    },
    texto: {
        fontSize: 18,
        color: 'dark'
    },
    titulo: {
        fontWeight: 'bold',
        color: 'dark',
        fontSize: 22,

    },

}));
const CardsHeaderMobile = () => {


    const { DataOnp } = useContext(UserContext);
    const classes = useStyles();

    return (
        <TableContainer className={classes.root} component={Paper} elevation={2}  >

            <Table stickyHeader aria-label="sticky table" size="small" >

                <TableBody  >
                    {DataOnp.Antecedentes?.map((resul) => (


                        <TableRow hover >

                            <TableCell style={{ textAlign: 'center' }} >
                                {resul.Concepto} : <strong>{resul.Valor}</strong>
                            </TableCell>
                         
                        </TableRow>
                    ))}

                </TableBody>

            </Table>



        </TableContainer>

    );
}

export default CardsHeaderMobile;